<wr-new-data-table headerText="Gebäude"
                   localStorageIdentifier="building-work-item-overview"
                   [loadItemsFunction]="loadBuildings"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToBuilding($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="false">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="fullTextSearch" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="internalTenant">Firma</label>
          <wr-tenant-select id="internalTenant"
                            [showEmptyOption]="true"
                            [tenantType]="TenantTypeEnum.Internal"
                            formControlName="assignedInternalTenantId">
          </wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="tenantSelect">Kunden</label>
          <wr-tenant-select id="tenantSelect"
                            formControlName="ownerTenantId"
                            [tenantType]="TenantTypeEnum.External"
                            [showEmptyOption]="true">
          </wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="regionSelect">Bereich</label>
          <wr-region-select id="regionSelect" formControlName="region" [tenantId$]="form.get('ownerTenantId')?.valueChanges"></wr-region-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="teamSelect">Team</label>
          <wr-team-select id="teamSelect" formControlName="team" [tenantId$]="form.get('ownerTenantId')?.valueChanges" [regionId$]="form.get('regionId')?.valueChanges"></wr-team-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="hasMonitoring">Monitoring</label>
          <nb-select id="hasMonitoring" formControlName="hasMonitoring" placeholder="Alle">
            <nb-option [value]="null">Alle</nb-option>
            <nb-option [value]="true">Ja</nb-option>
            <nb-option [value]="false">Nein</nb-option>
          </nb-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="sectionText"
    exportKey="sectionText"
    display="Adresse">
    @if (building.sectionText) {
      <div>
        {{building.sectionText}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="internalNumber"
    display="Int. Nummer">
    @if (building.internalNumber) {
      <div>
        {{building.internalNumber}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="assignedInternalTenants"
    [sortable]="false"
    [exportValue]="exportAssignedInternalTenants"
    display="Zuständige Firmen">
    {{ displayAssignedInternalTenants(building.assignedInternalTenants) }}
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="inspectionCount"
    [sortable]="false"
    display="Rundgänge">
    @if (building.inspectionCount > 0) {
      <div>
        {{building.sentInspectionCount}} / {{ building.inspectionCount }}
      </div>
    } @else {
      0
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="buildingEquipmentCount"
    [sortable]="false"
    display="TGAs">
    {{ building.buildingEquipmentCount }}
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="scanCount"
    [sortable]="false"
    display="Scans">
    {{ building.scanCount }}
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="monitoring"
    [exportValue]="exportMonitoring"
    display="Monitoring">
    {{ building.hasMonitoring ? 'Ja' : 'Nein' }}
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="ownerTenant"
    exportKey="ownerTenant.name"
    display="Kunde">
    <wr-tenant-badge [tenant]="building.ownerTenant"></wr-tenant-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="region"
    [sortable]="false"
    exportKey="team.region.name"
    display="Bereich">
    <wr-region-badge [region]="building.team?.region"></wr-region-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="team"
    [sortable]="false"
    exportKey="team.name"
    display="Team">
    <wr-team-badge [team]="building.team"></wr-team-badge>
  </ng-template>
</wr-new-data-table>
